import React from 'react';
import { Link } from 'react-router-dom';
import PlanAwareLink from '../billing/PlanAwareLink';
import PlanTierLabel from '../billing/PlanTierLabel';
import { requiredPlanLabel } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';
import './appNav.css';

export function NavShortcut({ to, label, description, variant = 'secondary', badge, planFeature }) {
  const { canUseFeature } = useUserPlan();
  const locked = planFeature && !canUseFeature(planFeature);
  const Cmp = locked ? PlanAwareLink : Link;
  const tier = planFeature ? requiredPlanLabel(planFeature) : null;

  return (
    <Cmp to={to} className={`nav-shortcut nav-shortcut--${variant}`}>
      <span className="nav-shortcut-label">
        {label}
        {locked && tier && <PlanTierLabel tier={tier} />}
        {badge != null && badge !== '' && (
          <span className="nav-shortcut-badge">{badge}</span>
        )}
      </span>
      {description && <span className="nav-shortcut-desc">{description}</span>}
    </Cmp>
  );
}

export default function NavShortcutGrid({ children, className = '' }) {
  return (
    <div className={`nav-shortcut-grid ${className}`.trim()} role="navigation">
      {children}
    </div>
  );
}
